export const BLOGS_ON_DELETE_REQUESTED = 'BLOGS_ON_DELETE_REQUESTED';
export const BLOGS_ON_DELETE_SUCCEEDED = 'BLOGS_ON_DELETE_SUCCEEDED';
export const BLOGS_ON_DELETE_FAILED = 'BLOGS_ON_DELETE_FAILED';

export const BLOGS_ON_GET_ALL_REQUESTED = 'BLOGS_ON_GET_ALL_REQUESTED';
export const BLOGS_ON_GET_ALL_SUCCEEDED = 'BLOGS_ON_GET_ALL_SUCCEEDED';
export const BLOGS_ON_GET_ALL_FAILED = 'BLOGS_ON_GET_ALL_FAILED';

export const BLOGS_ON_GET_ONE_REQUESTED = 'BLOGS_ON_GET_ONE_REQUESTED';
export const BLOGS_ON_GET_ONE_SUCCEEDED = 'BLOGS_ON_GET_ONE_SUCCEEDED';
export const BLOGS_ON_GET_ONE_FAILED = 'BLOGS_ON_GET_ONE_FAILED';

export const BLOGS_ON_SAVE_REQUESTED = 'BLOGS_ON_SAVE_REQUESTED';
export const BLOGS_ON_SAVE_SUCCEEDED = 'BLOGS_ON_SAVE_SUCCEEDED';
export const BLOGS_ON_SAVE_FAILED = 'BLOGS_ON_SAVE_FAILED';
